import {default as cx} from "classnames"
import {Link} from "react-router-dom"

const MetricsDropdownMenu = ({allowedRoutes}) => {
    return (
        <div className="d-flex menu menu-sub menu-sub-dropdown menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px">
            {allowedRoutes.map((route, index) => {
                return (
                    <div key={`metrics-dropdown-${route.key}-${index}`} className="menu-item px-5">
                        <Link to={route.link} className="menu-link rounded-2">
                            <i className={cx("fas text-primary fs-1 w-30px flex-center h-30px me-2", route.icon)}></i>
                            <span className="d-flex flex-column flex-grow-1">
                                <span className="fs-5 fw-bold text-gray-800">{route.name}</span>
                                <span className="fs-7 fw-semibold text-gray-800">{route.description}</span>
                            </span>
                        </Link>
                    </div>
                )
            })}
        </div>
    )
}

export default MetricsDropdownMenu
